import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, ContactListParams, ContactListResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<ContactListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchContactList = async (params: ContactListParams): Promise<ContactListResponse> => {
	const url = apiEndpoints.contacts.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useContactList = (params: ContactListParams, options?: QueryOptions) => {
	return useQuery<ContactListResponse, ApiError>({
		queryKey: ['contact', 'list', params],
		queryFn: () => fetchContactList(params),
		...options,
	});
};

export default useContactList;
